import { render } from "./GoRateEdit.vue?vue&type=template&id=35d61c7c&ts=true"
import script from "./GoRateEdit.vue?vue&type=script&lang=ts"
export * from "./GoRateEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__